module.exports = __webpack_public_path__ + "static/media/bomb.7176c52e.svg";